import styled from "styled-components";
import Img from "gatsby-image";
import { FaRegLightbulb } from "react-icons/fa";
import { TiInputChecked } from "react-icons/ti";

export const TestimonialsContainer = styled.div`
  color: #1c0824;
  width: 100%;
  height: 100%;
  z-index: 100;
  padding: 20px;
  @media screen and (max-width: 320px) {
    padding: 0px;
    justify-content: center;
    align-items: center;
  }
`;
export const TopLine = styled.p`
  color: #1c0824;
  font-size: 24px;
`;
export const Description = styled.p`
  display: block;
  font-size: 16px;
  font-weight: 100px;
  color: #7d605f;
`;
export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0;
  margin-left: 2rem;

  @media screen and (max-width: 786px) {
    grid-template-columns: 1fr;
  }
  @media screen and (max-width: 466px) {
    margin-left: 0.1rem;
    margin-right: 0.1rem;
    display: block;
  }
`;
export const ColumnOne = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 786px) {
    grid-template-columns: 1fr;
  }
`;
export const Testimonial = styled.div`
  padding-top: 1rem;
  padding-right: 1.5rem;
  h3 {
    margin-bottom: 1rem;
    display: block;
    font-size: 20px;
    font-style: italic;
  }
  p {
    display: block;
    color: #7d605f;
  }
  @media screen and (max-width: 486px) {
    display: block;
    max-width: 300;
  }
`;
export const ColumnTwo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 2rem;
  grid-gap: 10px;
  /* height: 300px; */
  @media screen and (max-width: 786px) {
    display: block;
    /* width: 300px; */
    margin-right: 10px;
  }
  @media screen and (max-width: 486px) {
    display: block;
    width: 300px;
    margin-right: 0px;
  }
  @media screen and (max-width: 306px) {
    display: block;
    width: 220px;
    margin-right: 0px;
  }
`;
export const TestimonialImageCard = styled.div`
  line-height: 2;
  width: 100%;
  height: 300px;
  position: relative;
  border-radius: 5px;
  transition: 0.2 ease;
`;
export const Images = styled(Img)`
  border-radius: 5px;
  height: 100%;
  filter: brightness(70%);
  @media screen and (max-width: 786px) {
    display: block;
    /* width: 300px; */
    margin-right: 10px;
    margin-top: 2rem;

  }
`;
